import React from 'react';
import Icon from '../../../components/AppIcon';

const AcademicLevelSelector = ({ onSelect, selectedLevel }) => {
  const levels = [
    {
      id: 'middle-school',
      title: 'Collège',
      subtitle: '6ème - 3ème',
      description: 'Parcours simplifié avec exploration de carrières adaptée aux collégiens',
      icon: 'BookOpen',
      color: 'bg-green-500',
      features: ['Questions simplifiées', 'Exploration ludique', 'Accompagnement familial']
    },
    {
      id: 'high-school',
      title: 'Lycée',
      subtitle: 'Seconde - Terminale',
      description: 'Évaluation détaillée des matières et préférences pour l\'orientation post-bac',
      icon: 'GraduationCap',
      color: 'bg-blue-500',
      features: ['Évaluation des matières', 'Choix de série', 'Objectifs académiques']
    },
    {
      id: 'university',
      title: 'Études Supérieures',
      subtitle: 'Post-Bac',
      description: 'Formulaire complet pour les étudiants universitaires avec historique académique',
      icon: 'Award',
      color: 'bg-purple-500',
      features: ['Historique complet', 'Préférences universitaires', 'Spécialisation']
    }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-lg p-6">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-500 rounded-full mb-4">
            <Icon name="Compass" size={32} color="#FFFFFF" />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">
            Choisissez Votre Niveau Académique
          </h3>
          <p className="text-base text-gray-600">
            Sélectionnez votre niveau pour un parcours d'inscription adapté à vos besoins
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {levels?.map((level) => (
          <button
            key={level?.id}
            onClick={() => onSelect(level?.id)}
            className={`relative bg-white border-2 rounded-xl p-6 text-left transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${
              selectedLevel === level?.id
                ? 'border-blue-500 shadow-lg'
                : 'border-gray-200 hover:border-blue-300'
            }`}
          >
            <div className={`inline-flex items-center justify-center w-14 h-14 ${level?.color} rounded-full mb-4`}>
              <Icon name={level?.icon} size={28} color="#FFFFFF" />
            </div>

            <h4 className="text-xl font-bold text-gray-900 mb-1">
              {level?.title}
            </h4>
            <p className="text-sm font-medium text-blue-600 mb-3">
              {level?.subtitle}
            </p>
            <p className="text-sm text-gray-600 mb-4">
              {level?.description}
            </p>

            <div className="space-y-2">
              {level?.features?.map((feature, index) => (
                <div key={index} className="flex items-center gap-2">
                  <Icon name="Check" size={16} className="text-green-500" />
                  <span className="text-xs text-gray-700">{feature}</span>
                </div>
              ))}
            </div>

            {selectedLevel === level?.id && (
              <div className="absolute top-4 right-4">
                <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                  <Icon name="Check" size={20} color="#FFFFFF" />
                </div>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AcademicLevelSelector;